import { render, staticRenderFns } from "./MakinaList.vue?vue&type=template&id=4c7d7e9b&"
import script from "./MakinaList.vue?vue&type=script&lang=js&"
export * from "./MakinaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports